<template>
    <b-modal v-model="showModal" @hidden="cancelarSalvar" size="xl" hide-footer :title="prefix + title">
        <b-form @submit.prevent="submitForm">
            <div>
                <b-card class='mt-3' bg-variant="light">
                    <b-row>
                        <b-col md="6">
                            <LgFormInput v-model="form.numeroAta" :disabled="true" label="Número Ata:*" />
                        </b-col>

                        <b-col md="6">
                            <LgFormConstSelect label="Motivo da Solicitação:*" v-model="form.motivoSolicitacao"
                                :options="motivosOption" :disabled="isViewMode" />
                        </b-col>

                        <b-col md="6">
                            <LgFormInput v-model="form.justificativa" :disabled="isViewMode"
                                label="Justificativa Detalhada:*" />
                        </b-col>
                        <b-col md="6">
                            <LgFormDate label="Data da Solicitação:*" description='' v-model="form.dhSolicitacao"
                                :disabled="isViewMode" />
                        </b-col>

                    </b-row>
                </b-card>
            </div>
            <b-row v-if="!isViewMode" no-gutters class="my-2 d-flex justify-content-end">
                <b-col md="12" class="d-flex justify-content-end">
                    <b-button @click="refresh" variant="primary" class="mb-2" :disabled="isViewMode">
                        <b-icon icon="arrow-repeat"></b-icon>
                    </b-button>
                </b-col>
            </b-row>
            <b-table ref="bTable" :items="form.itens" :fields="fields" responsive="sm" :busy="busy">
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>
                <template #cell(descricaoResumida)="data">
                    <span @click="downloadArquivoService(data.item)" :class="data.item.arquivo ? 'custom-link' : ''">{{
                        data.item.descricaoResumida }}</span>
                </template>
                <template #cell(valorNovo)="data">
                    <b-form-input style="height: 20px;" :disabled="isViewMode" v-model="data.item.valorNovo"
                        type="number" min="0" step="0.01"></b-form-input>

                </template>
                <template #cell(arquivo)="data">
                    <button :disabled="isViewMode" size="sm" variant="primary"  @click="triggerFileInput">
                        <b-icon icon="file-earmark"  font-scale="1.2" variant="primary" />
                    </button>
                    <b-form-file ref="fileInput" class="d-none" id="documentoInput"
                        accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        @change="(event) => { handleArquivo(event, data.item) }"></b-form-file>

                </template>
                <template #cell(acoes)="data">
                    <b-button @click="handleRemoveItem(data.index)" variant="danger" size="sm" :disabled="isViewMode">
                        <b-icon icon="trash" />
                    </b-button>
                </template>

                <template #cell(tipoArquivo)="data">
                    <LgFormConstSelect class='mt-3' v-model="data.item.tipoArquivo" :options="tipoDocumentoOptions"
                        :disabled="isViewMode" />
                </template>

            </b-table>
            <div class="d-flex justify-content-center mt-3">
                <b-button id="confirmarSalvar" @click="submitForm" variant="success" style="height: 30px" pill size="sm"
                    :disabled="(!isViewMode ? false : (isViewMode && isCarona == null ? isViewMode : !isCarona))">
                    <div class="btn-size-alinhamento">
                        <b-icon icon="check-circle" />
                    </div>
                </b-button>
                <b-button id="cancelarSalvar" class="ml-2" @click="cancelarSalvar" style="height: 30px" pill size="sm"
                    variant="danger">
                    <div class="btn-size-alinhamento">
                        <b-icon icon="x-circle" />
                    </div>
                </b-button>
            </div>


        </b-form>
    </b-modal>
</template>

<script>
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { ListResourceMixin } from "@/core/mixins/resource";
import ResourceService from "@/core/api/ResourceService";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import { FormResourceMixin } from "@/core/mixins/resource";

export default {
    components: {
        LgFormConstSelect,
        LgFormDate,
        LgFormInput,
    },
    mixins: [ListResourceMixin, FormResourceMixin],
    props: {
        id: {
            type: Number,
            default: null
        },
        isCarona: {
            type: Boolean,
            default: null,
        },
        prefix: {
            type: String,
            default: "",
        },
        idAta: {
            type: Number,
            default: null,
        },
        isViewMode: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: "Cadastrar"
        }
    },
    data() {
        return {
            motivosOption: [
                { value: null, text: "Selecione o motivo" },
                { value: 0, text: "Reequilíbrio" },
                { value: 1, text: "Correção" },
                { value: 1, text: "Outro" },
            ],

            tipoDocumentoOptions: [
                { value: null, text: "Selecione o tipo de documento" },
                { value: "5", text: "Ofício" },
                { value: "70", text: "Planilha" },
                { value: "77", text: "Estudo Técnico" },
            ],

            showModal: true,
            busy: false,
            form: {
                numeroAta: "",
                motivoSolicitacao: null,
                justificativa: "",
                dhSolicitacao: "",
            },
            fields: [
                { key: 'descricaoResumida', label: 'Produto' },
                { key: 'quantidade', label: 'Quantidade' },
                { key: 'unidadeMedida', label: 'Unidade' },
                { key: 'valorUnit', label: 'Valor Antigo' },
                { key: 'valorNovo', label: 'Valor Novo' },
                { key: 'tipoArquivo', label: 'Tipo Arquivo' },

                { key: 'total', label: 'Total' },
                { key: 'arquivo', label: '' },

                { key: 'acoes', label: '' },
            ],
        }
    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/ata-solicitacao-atualizacao-valor`);

        this.refresh();

    },
    methods: {
        async downloadArquivoService(item) {
            if (!this.id)
                return;
            const { data } = await new ResourceService(`/api/arquivos/${item.arquivo.id}`).get('download')

            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;

            let fileName = item.arquivo.nome + '.pdf';

            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);

        },
        async findById() {
            var { data } = await new ResourceService("/api/ata-solicitacao-atualizacao-valor").get(this.id);
            this.busy = false;
            this.form = data;

        },

        triggerFileInput() {
            document.getElementById("documentoInput").click();
        },
        handleArquivo(event, item) {
            var file = event.target.files[0];

            if (file) {
                if (file.type !== 'application/pdf' || !file.name.toLowerCase().endsWith('.pdf')) {
                    this.$notify({
                        type: "danger",
                        message: "Apenas arquivos PDF são permitidos."
                    });
                    event.target.value = '';
                    return;
                }

                var nomeArquivo = file.name;
                var reader = new FileReader();
                reader.onload = (e) => {
                    const bytes = Array.from(new Uint8Array(e.target.result));
                    item.arquivo = { nome: nomeArquivo, arquivo: bytes };
                    this.$nextTick(() => this.$refs.bTable.refresh());

                };
                reader.readAsArrayBuffer(file);
            }

        },
        async refresh() {
            this.busy = true;

            if (this.id != null) {
                this.findById();
            }
            else {
                var { data } = await new ResourceService("/api/atas/simplificado-itens").get(this.idAta);
                this.busy = false;
                this.form.numeroAta = data.numeroAta;
                this.form.itens = data.itens;

            }


        },
        handleRemoveItem(index) {

            this.busy = true;
            this.form.itens.splice(index, 1)
            this.busy = false;
            this.$nextTick(() => this.$refs.bTable.refresh());


        },
        async submitForm() {

            if (this.form.motivoSolicitacao == null) {
                this.$notify({
                    type: "danger",
                    message: "Digite um motivo"
                });

                return;
            }

            if (!this.form.justificativa || this.form.justificativa == "") {
                this.$notify({
                    type: "danger",
                    message: "Digite uma justificativa"
                });

                return;
            }

            if (!this.form.dhSolicitacao || this.form.dhSolicitacao == "") {
                this.$notify({
                    type: "danger",
                    message: "Digite uma data de solicitação"
                });

                return;
            }

            var itensSemValor = this.form.itens.some(item => !item.valorNovo)

            if (itensSemValor) {
                this.$notify({
                    type: "danger",
                    message: "Todos os itens precisam ter um valor novo. Digite um valor ou remova o item da lista"
                });
                return;
            }


            var itensSemTipo = this.form.itens.some(item => !item.tipoArquivo || !item.arquivo)

            if (itensSemTipo) {
                this.$notify({
                    type: "danger",
                    message: "Todos os itens precisam ter um tipo de arquivo e um arquivo selecionado."
                });
                return;
            }


            try {

                this.form.ata = this.idAta;

                await this.$saveResource(this.form, "", false, {}, false, true)
                this.cancelarSalvar();

            }
            catch (error) {
                return error;
            }


        },
        cancelarSalvar() {
            this.$emit('close')
        },
        formatDate(dateString) {
            if (!dateString) return "N/A"
            const date = new Date(dateString)
            const day = String(date.getDate()).padStart(2, '0')
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const year = date.getFullYear()
            return `${day}/${month}/${year}`
        },
        async convertFileToBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.onload = () => resolve(reader.result.split(',')[1])
                reader.onerror = reject
                reader.readAsDataURL(file)
            })
        },
    },
}
</script>

<style scoped>
.custom-link {
    color: blue;
    text-decoration: underline;
    text-align: center;
    cursor: pointer;
}
</style>